module.exports = __webpack_public_path__ + "static/media/icon-about.12530910.png";